import Swiper from "swiper";
import { A11y, FreeMode, Scrollbar } from "swiper/modules";
import "@/styles/components/slider.css";

document.querySelectorAll(".element-expandingimagecards").forEach((el) => {
  const container = el.querySelector(".swiper");
  const numSlides = el.querySelectorAll(".swiper-slide").length;

  const swiper = new Swiper(container, {
    modules: [A11y, FreeMode, Scrollbar],
    slidesPerView: "auto",
    spaceBetween: 36,
    speed: 700,
    freeMode: {
      enabled: true,
      momentumRatio: 0.8,
    },
    scrollbar: {
      el: el.querySelector(".swiper-scrollbar"),
      draggable: true,
    },
    breakpoints: {
      640: {
        scrollbar: {
          enabled: numSlides > 2,
        },
      },
    },
  });

  const slides = container.querySelectorAll(".swiper-slide");

  slides.forEach((slide, index) => {
    const figure = slide.querySelector("figure");

    figure.addEventListener("click", () => {
      const wasExpanded = slide.classList.contains("expanded");
      const currentWidth = slide.offsetWidth;

      slides.forEach((s) => {
        s.classList.remove("expanded");

        if (s.style.width) {
          s.style.width = "";

          const onCollapse = (e) => {
            if (e.propertyName !== "width" || e.target !== s) return;

            s.removeEventListener("transitionend", onCollapse);
            s.style.maxWidth = "";

            const t = s.querySelector("figure p");

            if (t) t.style.fontSize = "";
          };

          s.addEventListener("transitionend", onCollapse);
        }
      });

      if (!wasExpanded) {
        slide.classList.add("expanded");

        if (window.innerWidth >= 1280) {
          const title = slide.querySelector("figure p");

          if (title) title.style.fontSize = getComputedStyle(title).fontSize;

          slide.style.width = `${currentWidth * 1.6}px`;
          slide.style.maxWidth = "none";
        }
      }

      const onEnd = (e) => {
        if (e.propertyName !== "width" || e.target !== slide) return;

        slide.removeEventListener("transitionend", onEnd);

        const prev = swiper.translate;
        swiper.update();

        const updated = swiper.translate;

        if (updated !== prev) {
          swiper.wrapperEl.style.transitionDuration = "0ms";
          swiper.setTranslate(prev);
          swiper.wrapperEl.offsetHeight;
        }

        if (wasExpanded) {
          if (updated !== prev) {
            swiper.translateTo(updated, 700);
          }
        } else {
          swiper.slideTo(index);
        }
      };
      slide.addEventListener("transitionend", onEnd);
    });
  });
});
